import { CarRank } from '../../../../../components/stats/carRank/CarRank'
import './QuickVehicleSpecTitle.css'

export interface QuickVehicleSpecTitleProps {

	brand: string,
	name: string,
	rank: number

}

export const QuickVehicleSpecTitle = ({ brand, name, rank }: QuickVehicleSpecTitleProps) => {

	return (<>
		<div className='quick-vehicle-specification-title'>

			<div className='quick-vehicle-spec-title-header-wrapper'>
				<div className='quick-vehicle-spec-title-header'>
					<p>{brand}</p>
					<CarRank style={{ width: 30, height: 20, fontSize: '.8rem' }} rank={rank} />
				</div>

				<div className='quick-vehicle-spec-title-content'>
					<p>{name}</p>
				</div>
			</div>
		</div>
	</>)
}